import React from "react";
import BlockContent from "./block-content";

function BlogPost(props) {
  const { _rawBody } = props;
  return <>{_rawBody && <BlockContent blocks={_rawBody} />}</>;
}

export default BlogPost;
